"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tertiaryExpectedColor = exports.tertiaryExpectedBgColor = exports.primaryExpectedColor = exports.primaryExpectedBgColor = exports.TERTIARY_HORIZONTAL_PADDING = exports.SMALL_BUTTON_WIDTH = exports.REGULAR_BUTTON_WIDTH = exports.REGULAR_BUTTON_HEIGHT = exports.OUTLINE_WIDTH = exports.BORDER_WIDTH = exports.BORDER_RADIUS = void 0;

var _utils = require("../utils");

var BORDER_WIDTH = 2;
exports.BORDER_WIDTH = BORDER_WIDTH;
var OUTLINE_WIDTH = 2;
exports.OUTLINE_WIDTH = OUTLINE_WIDTH;
var REGULAR_BUTTON_HEIGHT = Math.max(48, _utils.A11Y_MIN_SIZE);
exports.REGULAR_BUTTON_HEIGHT = REGULAR_BUTTON_HEIGHT;
var SMALL_BUTTON_WIDTH = 96;
exports.SMALL_BUTTON_WIDTH = SMALL_BUTTON_WIDTH;
var REGULAR_BUTTON_WIDTH = 128;
exports.REGULAR_BUTTON_WIDTH = REGULAR_BUTTON_WIDTH;
var TERTIARY_HORIZONTAL_PADDING = 16;
exports.TERTIARY_HORIZONTAL_PADDING = TERTIARY_HORIZONTAL_PADDING;
var BORDER_RADIUS = '1000px';
exports.BORDER_RADIUS = BORDER_RADIUS;
var primaryExpectedBgColor = (0, _utils.getRgbColorFromTheme)('primary70');
exports.primaryExpectedBgColor = primaryExpectedBgColor;
var primaryExpectedColor = (0, _utils.getRgbColorFromTheme)('neutral0');
exports.primaryExpectedColor = primaryExpectedColor;
var tertiaryExpectedBgColor = 'transparent';
exports.tertiaryExpectedBgColor = tertiaryExpectedBgColor;
var tertiaryExpectedColor = (0, _utils.getRgbColorFromTheme)('primary70');
exports.tertiaryExpectedColor = tertiaryExpectedColor;